import { Link } from "react-router-dom";

const NoMatch = () => {
    return (
        <div>
            <h2>Not Found (404)</h2>
            <p>
               The resource you were looking for could not be found. Please return to the <Link to="/">dashboard</Link>
            </p>
        </div>
    );
};

export default NoMatch;